<template>
  <v-app>
    <en-navigation-bar>
      <router-view></router-view>
    </en-navigation-bar>
  </v-app>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss" scoped>
</style>